import { useCallback } from 'react'
import { useAppSelector } from "~/store/hooks";
import { Velocity } from 'store/units/types'
import { ImperialVelocity } from 'store/units/types/velocity'
import { FormattedUnitData, UnformattedUnitData } from '~/store/units/types/unit'

export interface VelocityFormatter {
  formatVelocity(imperialVelocity: Velocity<FormattedUnitData | UnformattedUnitData> | number, options?: { round?: number }): string | null
}

export const useFormatVelocity = (): VelocityFormatter => {
  const { VELOCITY } = useAppSelector(({ units }) => units)
  const isMetric = VELOCITY === 'METRIC'
  return {
    formatVelocity: useCallback(
      (imperialVelocity, options = { round: isMetric ? 2 : 0 }) => {
        const formatter = isMetric ? 'formatMetric' : 'formatImperial'
        if (imperialVelocity instanceof Velocity) {
          return imperialVelocity[formatter](options)
        } else {
          return new ImperialVelocity(imperialVelocity)[formatter](options)
        }
      },
      [isMetric]
    ),
  }
}
